import ExternalUtil from '../ExternalUtil';
import WaUtil from './WaUtil';

/** Utils for interacting with data layer objects */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class TrackingUtil {
  /** wrapper around window._mfq.push() */
  public static mouseFlowPush(toPush: (string | boolean)[]): void {
    window._mfq = window._mfq || [];

    if (!ExternalUtil.isProduction()) {
      console.log('mouseFlowPush', toPush);
    }
    window._mfq.push(toPush);

    WaUtil.waPush({
      event: 'MouseflowPush',
      data: {
        toPush,
      },
    });
  }

  /** safely wrappers around window.dataLayer */
  public static dataLayerPush(data: GoogleAnalyticsEventObject) {
    try {
      // getting strange build errors for window.ptcDebug
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const win: any = window || {};
      win.ptcDebug = win.ptcDebug || {};
      win.ptcDebug.dataLayerPushes = win.ptcDebug.dataLayerPushes || [];
      win.ptcDebug.dataLayerPushes.push(data);
    } catch {
      /** ignore */
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);

    WaUtil.waPush({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      event: data.event as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      data: data as any,
    });
  }
}
